import React from "react";
import "./desktopKpiStrip.css";

/**
 * Desktop-only KPI strip (P-03 in the desktop design library). Every tile
 * renders a real, already-loaded number (zero included) — never a placeholder
 * metric. Hidden below 1024px, so mobile screens are unchanged.
 *
 * tiles: [{ key, value, label, tone?: "gold"|"green"|"blue"|"red"|"muted" }]
 */
export function DesktopKpiStrip({ tiles, ariaLabel = "Summary", className = "" }) {
  const visible = (tiles || []).filter(Boolean);
  if (visible.length === 0) {
    return null;
  }

  return (
    <div
      className={`dk-strip ${className}`.trim()}
      role="group"
      aria-label={ariaLabel}
      data-testid="desktop-kpi-strip"
    >
      {visible.map((tile) => (
        <div
          key={tile.key}
          className={`dk-tile dk-tile--${tile.tone || "gold"}`}
        >
          <span className="dk-tile__dot" aria-hidden="true" />
          <span className="dk-tile__text">
            <span className="dk-tile__value">{tile.value}</span>
            <span className="dk-tile__label">{tile.label}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
